import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { defaultInfiniteQueryPlaceholderData } from '@@api/utils/defaultPlaceholderData';
import { type ContentLanguage } from '@@lib/i18n/constants';

export const PAGE_SIZE = 100;

export const geneeaEntityListQuery = (
    query: { q?: string; hasTag?: boolean },
    contentLocale: ContentLanguage,
) =>
    client.metadata.geneeaEntities.getAll.infiniteQueryOptions(
        {
            query: { ...query, size: PAGE_SIZE },
            headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
        },
        { placeholderData: defaultInfiniteQueryPlaceholderData(PAGE_SIZE) },
    );
